import React from "react";
import Profile from "./Profile";  // Import Profile component
import NavLinks from "./NavLinks"; // Import NavLinks component

const SideBar = () => {
  return (
    <header id="header">
      <div className="d-flex flex-column">
        <Profile />
        <NavLinks />
      </div>
    </header>
  );
};

export default SideBar;